<template>
  <div style="width:100%">
    <el-tiptap style="width:100%" v-model="content" :extensions="extensions" />
  </div>
</template>

<script>
import {
  // 需要的 extensions
  Doc,
  Text,
  Paragraph,
  Heading,
  Bold,
  Italic,
  Strike,
  Underline,
  Link,
  Image,
  // Iframe,
  CodeBlock,
  Blockquote,
  ListItem,
  BulletList,
  OrderedList,
  TodoItem,
  TodoList,
  TextAlign,
  Indent,
  LineHeight,
  HorizontalRule,
  HardBreak,
  TrailingNode,
  History,
  // Table,
  TableHeader,
  TableCell,
  TableRow,
  TextColor,
  TextHighlight,
  Preview,
  Print,
  // Fullscreen, 
  SelectAll,
  FontType,
  FontSize,
  CodeView,
} from "element-tiptap";
import {
  upload_image
} from "@/request/api/goods";
export default {
  props:['goodsDetail'],
  data() {
    return {
      // 编辑器的 extensions
      // 它们将会按照你声明的顺序被添加到菜单栏和气泡菜单中
      extensions: [
          new CodeView(),
          new FontSize(),
          new FontType(),
          new SelectAll(),
          // new Fullscreen(),
          new Print(),
          new Preview(),
          new TextHighlight(),
          new TextColor(),
          new TableRow(),
          new TableCell(),
          new TableHeader(),
          // new Table(),
          new History(),
          new TrailingNode(),
          new HardBreak(),
          new HorizontalRule(),
          new LineHeight(),
          new Indent(),
          new TextAlign(),
          new TodoList(),
          new TodoItem(),
          new Blockquote(),
        new CodeBlock(),
        // new Iframe(),
        new Link(),
        new Image(
          {
          // 默认会把图片生成 base64 字符串和内容存储在一起，如果需要自定义图片上传
          uploadRequest(file) {
            // debugger
            // 如果接口要求 Content-Type 是 multipart/form-data，则请求体必须使用 FormData
            const fd = new FormData()
            fd.append('file', file)
            // 第1个 return 是返回 Promise 对象
            // 为什么？因为 axios 本身就是返回 Promise 对象
            return upload_image(fd).then(res => {
              // debugger
              console.log("ssss",res)
              // 这个 return 是返回最后的结果
              return res.data.url
            })
          } // 图片的上传方法，返回一个 Promise<url>
        }
        ),
        new Doc(),
        new Text(),
        new Paragraph(),
        new Heading({ level: 5 }),
        new Bold({ bubble: true }), // 在气泡菜单中渲染菜单按钮
        new Underline({ bubble: true, menubar: false }), // 在气泡菜单而不在菜单栏中渲染菜单按钮
        new Italic(),
        new Strike(),
        new ListItem(),
        new BulletList(),
        new OrderedList(),
      ],
      // 编辑器的内容
      content: '',
    };
  },
  watch: {
    content(e){
      // this.goodsDetail = e
      this.$emit('changTiptap',e)
    }
  },
  created() {
    console.log(this.goodsDetail)
  },
  methods:{
  }
};
</script>